export enum SearchDirection {
    BySpectrumString,
    ByPeaks,
    ByZipFile,
  }
  